module.exports = __webpack_public_path__ + "static/akwarium-4-0caf52646cf043151351ecc7bbe82eb9.jpg";